import { render, staticRenderFns } from "./ArticleElement.vue?vue&type=template&id=349fca26&"
import script from "./ArticleElement.vue?vue&type=script&lang=js&"
export * from "./ArticleElement.vue?vue&type=script&lang=js&"
import style0 from "./ArticleElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports